import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk, createMultipartGraphQLThunk } from ".";
import {
  APPROVE_ORDERS,
  CHANGE_PENDING_AMOUNT,
  CHANGE_STATUS_IN_STORE,
  CHANGE_STATUS_OF_ORDER,
  GENERATE_MANIFEST,
  GET_BY_REF_ID,
  GET_INVOICES_BY_REFS,
  GET_ORDER_REMARK_HISTORY,
  GET_ORDER_REVENUE,
  GET_PAYMENT_DATA,
  GET_SELLER_LISTING,
  GET_SHIPMENT_DATA,
  GET_SHIPMENT_HISTORY,
  GET_SHIPMENT_INSTORE,
  GET_STORE_LISTING,
  GET_TRANSCATION_DATA,
  GET_VENDOR_SETTLEMENTS,
  GET_WAYUVEGA_LIST,
  ORDER_LISTING,
  ORDER_STATUS_BAR,
  PRINT_INVOICE,
  PRINT_LABEL,
  SAVE_ORDER_REMARK,
  UPLOAD_BLOOD_SAMPLE_REPORT,
} from "../../utils/queries";

export const OrderThunk = createAsyncThunk(
  "OrderSlice/OrderThunk",
  createGraphQLThunk({
    query: ORDER_LISTING,
    getVariables: ({ orderRequestFilters }) => ({ orderRequestFilters }),
    responseKey: "getCategorizedOrders",
  }),
);

export const OrderOverviewThunk = createAsyncThunk(
  "OrderOverviewSlice/OrderOverviewThunk",
  createGraphQLThunk({
    query: GET_BY_REF_ID,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getByRefId",
  }),
);

export const OrderTransactionThunk = createAsyncThunk(
  "OrderTransactionSlice/OrderTransactionThunk",
  createGraphQLThunk({
    query: GET_TRANSCATION_DATA,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getTransactionData",
  }),
);

export const OrderPaymentThunk = createAsyncThunk(
  "OrderPaymentSlice/OrderPaymentThunk",
  createGraphQLThunk({
    query: GET_PAYMENT_DATA,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getPaymentData",
  }),
);
export const SaveOrderRemarksThunk = createAsyncThunk(
  "OrderPaymentSlice/SaveOrderRemarksThunk",
  createGraphQLThunk({
    query: SAVE_ORDER_REMARK,
    getVariables: ({ id, remarks }) => ({ id, remarks }),
    responseKey: "saveOrderRemarks",
    onSuccessMessage: "Remarks Saved Successfully",
  }),
);

export const OrderRemarksHistoryThunk = createAsyncThunk(
  "OrderPaymentSlice/OrderRemarksHistoryThunk",
  createGraphQLThunk({
    query: GET_ORDER_REMARK_HISTORY,
    getVariables: ({ orderRefId, paginationFilter }) => ({
      orderRefId,
      paginationFilter,
    }),
    responseKey: "getOrderRemarksHistory",
  }),
);

export const OrderInStoreThunk = createAsyncThunk(
  "OrderInStoreSlice/OrderInStoreThunk",
  createGraphQLThunk({
    query: GET_SHIPMENT_INSTORE,
    getVariables: ({ orderRefId }) => ({
      orderRefId,
    }),
    responseKey: "getShippingDataInStore",
    notError: true,
  }),
);

export const OrderShippingThunk = createAsyncThunk(
  "OrderShippingSlice/OrderShippingThunk",
  createGraphQLThunk({
    query: GET_SHIPMENT_DATA,
    getVariables: ({ orderRefId }) => ({
      orderRefId,
    }),
    responseKey: "getShippingData",
    notError: true,
  }),
);

export const ChangeStatusInStoreThunk = createAsyncThunk(
  "ChangeStatusInStoreSlice/OrderChangeStatusInStoreThunk",
  createGraphQLThunk({
    query: CHANGE_STATUS_IN_STORE,
    getVariables: ({ orderStatusChangeRequest }) => ({
      orderStatusChangeRequest,
    }),
    responseKey: "changeStatusOfInStoreOrder",
  }),
);

export const OrderBarThunk = createAsyncThunk(
  "OrderBarSlice/OrderBarThunk",
  createGraphQLThunk({
    query: ORDER_STATUS_BAR,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getOrderStatusBar",
  }),
);

export const OrderChangeStatusThunk = createAsyncThunk(
  "OrderChangeStatusSlice/OrderChangeStatusThunk",
  createGraphQLThunk({
    query: CHANGE_STATUS_OF_ORDER,
    getVariables: ({ orderStatusChangeRequest }) => ({
      orderStatusChangeRequest,
    }),
    responseKey: "changeStatusOfOrder",
    onSuccessMessage: "Status Changed",
  }),
);

export const OrderShipmentHistoryThunk = createAsyncThunk(
  "OrderShipmentHistorySlice/OrderShipmentHistoryThunk",
  createGraphQLThunk({
    query: GET_SHIPMENT_HISTORY,
    getVariables: ({ orderRefID, id }) => ({ orderRefID, id }),
    responseKey: "shipmentHistory",
  }),
);

export const PrintInvoiceThunk = createAsyncThunk(
  "PrintInvoiceSlice/PrintInvoiceThunk",
  createGraphQLThunk({
    query: PRINT_INVOICE,
    getVariables: ({ id }) => ({ id }),
    responseKey: "getInvoiceByRef",
    onSuccessMessage: "Invoice Downloaded Sucessfully",
  }),
);

export const PrintLabelThunk = createAsyncThunk(
  "PrintLabelSlice/PrintLabelThunk",
  createGraphQLThunk({
    query: PRINT_LABEL,
    getVariables: ({ shipmentId, shippingPartner }) => ({
      shipmentId,
      shippingPartner,
    }),
    responseKey: "getLabelByShipmentId",
    onSuccessMessage: "Label Downloaded Sucessfully",
  }),
);

export const ApproveOrderThunk = createAsyncThunk(
  "ApproveOrderSlice/ApproveOrderThunk",
  createGraphQLThunk({
    query: APPROVE_ORDERS,
    getVariables: ({ approveOrderRequest }) => ({
      approveOrderRequest,
    }),
    responseKey: "approveOrdersByRefId",
  }),
);

export const PendingAmountThunk = createAsyncThunk(
  "ChangePendingAmountSlice/PendingAmountThunk",
  createGraphQLThunk({
    query: CHANGE_PENDING_AMOUNT,
    getVariables: ({ pendingAmountReceived, orderRefID }) => ({
      pendingAmountReceived,
      orderRefID,
    }),
    responseKey: "changePendingAmountForCOD",
  }),
);

export const WayuvegaThunk = createAsyncThunk(
  "SplitOrderSlice/WayuvegaThunk",
  createGraphQLThunk({
    query: GET_WAYUVEGA_LIST,
    getVariables: ({ orderRefId, shippingPartner }) => ({
      orderRefId,
      shippingPartner,
    }),
    responseKey: "getApplicableShippingPartners",
  }),
);

export const OrderRevenueThunk = createAsyncThunk(
  "SplitOrderSlice/OrderRevenueThunk",
  createGraphQLThunk({
    query: GET_ORDER_REVENUE,
    getVariables: ({ orderRequestFilters }) => ({
      orderRequestFilters,
    }),
    responseKey: "getRevenueWithOrders",
  }),
);

export const SettlementThunk = createAsyncThunk(
  "SettlementSlice/SettlementThunk",
  createGraphQLThunk({
    query: GET_VENDOR_SETTLEMENTS,
    getVariables: ({ paginationFilter }) => ({
      paginationFilter,
    }),
    responseKey: "getVendorSettlements",
  }),
);

export const getSellerListingThunk = createAsyncThunk(
  "getSellerListingSlice/getSellerListingThunk",
  createGraphQLThunk({
    query: GET_SELLER_LISTING,
    getVariables: () => ({}),
    responseKey: "getSellerListing",
    url: process.env.REACT_APP_VENDOR,
    notError: true,
  }),
);

export const getStoresListingThunk = createAsyncThunk(
  "getStoresListingSlice/getStoresListingThunk",
  createGraphQLThunk({
    query: GET_STORE_LISTING,
    getVariables: (vendorId) => ({ vendorId }),
    responseKey: "getStoresListing",
    url: process.env.REACT_APP_VENDOR,
    notError: true,
  }),
);

export const GenerateManifestThunk = createAsyncThunk(
  "getStoresListingSlice/GenerateManifestThunk",
  createGraphQLThunk({
    query: GENERATE_MANIFEST,
    getVariables: ({ orderId, storeId }) => ({ orderId, storeId }),
    responseKey: "exportManifest",
    url: process.env.REACT_APP_VENDOR,
    notError: true,
    onSuccessMessage: "Manifest Generated Successfully!!",
  }),
);


export const UploadBloodSampleReportThunk = createAsyncThunk(
   "UploadBloodSampleReportSlice/UploadBloodSampleReportThunk",
  createMultipartGraphQLThunk({
    query: UPLOAD_BLOOD_SAMPLE_REPORT,
    getVariables: ({ reportUploadRequest }) => ({ reportUploadRequest }),
    fileKeys: [
      "reportUploadRequest.report",           
    ],
    responseKey: "uploadSampleReport",
    onSuccessMessage: "Blood Sample Report uploaded Successfully!"
  })
);


export const getInvoicesByRefsThunk = createAsyncThunk(
  "getInvoicesByRefsSlice/getInvoicesByRefsThunk",
  createGraphQLThunk({
    query: GET_INVOICES_BY_REFS,
    getVariables: ({ orderRefIds }) => ({ orderRefIds }),
    responseKey: "getInvoicesByRefs",
    url: process.env.REACT_APP_VENDOR,
    notError: true,
    onSuccessMessage: "Invoice Generated Successfully!!",
  }),
);